/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-22T14:26:55+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-28T15:38:23+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MInputText from './MInputText';
import {
  createNumberMask,
  createNumberParser,
  createNumberFormatter,
} from './../masks/numberMask';


const maskOptions = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2,
  requireDecimal: false,
  allowNegative: false,
};

const formatterOptions = {
  ...maskOptions,
  requireDecimal: true, // for the formatter we require the decimals
};

/**
 * OInputCurrency - …
**/
class OInputCurrency extends Component {
  constructor(props) {
    super(props);
    const initialValue = (this.isControlled()) ? props.value : props.defaultValue;

    this.state = {
      value: initialValue,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.isControlled()) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  render() {
    const {
      id,
      value, // eslint-disable-line no-unused-vars
      placeholder,
      defaultValue,
      unit,
      parser, // eslint-disable-line no-unused-vars
      formatter, // eslint-disable-line no-unused-vars
      mask,
      onChange, // eslint-disable-line no-unused-vars
      ...other
    } = this.props;

    return (
      <div className="o-input o-input-currency">
        <MInputText
          {...other}
          id={id}
          unit={unit}
          placeholder={placeholder}
          value={this.state.value}
          onChange={(e) => this.handleOnChange(e)}
          onKeyPress={ (e) => {
            if ( e.charCode >= 48 && e.charCode <= 57 && e.target.value.length > 4 ) {
              e.stopPropagation();
              e.preventDefault();
            }
          }}
        />
      </div>
    );
  }

  handleOnChange(event) {
    const {onChange} = this.props;
    if (!this.isControlled()) {
      this.setState({
        value: event.target.value,
      });
    }

    if (onChange) onChange(event);
  }

  isControlled() {
    return Object.prototype.hasOwnProperty.call(this.props, 'value');
  }
}
OInputCurrency.propTypes = {
  /**
     * id of the input field to link it with a labels htmlFor attribute
     */
  id: PropTypes.string,
  /**
     * value of the input
     * NOTE: it may occure strange behaviour when using it as
     * a controlled component and a mask which allows non-digit values.
     * In this case, if onChange passes
     */
  value: PropTypes.string,
  /**
     * placeholder for input
     */
  placeholder: PropTypes.string,
  /**
     * default value of the input
     */
  defaultValue: PropTypes.string,
  /**
     * optionally display a unit on the right
     */
  unit: PropTypes.string,
  /**
     * function which parses the input string-value and returns it
     * as a number or null
     */
  parser: PropTypes.func.isRequired,
  /**
     * function or array which describes the format-mask of the input
     */
  mask: PropTypes.func.isRequired,
  /**
     * function which uses the number value and formats it to the mask style
     */
  formatter: PropTypes.func.isRequired,
  /**
     * fired, when the input value changes
     */
  onChange: PropTypes.func,
};
OInputCurrency.defaultProps = {
  defaultValue: '',
  unit: 'euro',
  mask: createNumberMask(maskOptions),
  parser: createNumberParser(maskOptions),
  formatter: createNumberFormatter(formatterOptions),
};
export default OInputCurrency;

